// require('/');
// require('/assets/js/jquery-migrate-1.2.1.min.js');
// require('/assets/js/jquery.fittext.js');
// require('/assets/js/jquery.countdown.min.js');
// require('/assets/js/main.js');
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component
export default class Marketing2020Annual extends Vue {


    public async loadScript(url: string) {
        return new Promise(function (resolve, reject) {
            let s;
            s = document.createElement('script');
            s.src = url;
            s.onload = resolve;
            s.onerror = reject;
            document.head.appendChild(s);
        });
    }

    public created() {
    }

    public async mounted() {
        await this.loadScript('/assets/js/jquery-1.11.3.min.js');
        await this.loadScript('/assets/js/jquery-migrate-1.2.1.min.js');
        await this.loadScript('/assets/js/jquery.fittext.js');
        await this.loadScript('/assets/js/moment.min.js');
        await this.loadScript('/assets/js/moment-timezone-with-data.min.js');
        await this.loadScript('/assets/js/jquery.countdown.min.js');
        await this.loadScript('/assets/js/main-2020-final.js');
    }
}
